import { BanRecordSchema } from "../../admin/ban";
import { HubExchangeAccount } from "./exchangeAccount";
import z from "zod";

export const HubUserSchema = z.object({
  id: z.number(),
  // Null for users who signed up with email OTP and haven't linked a wallet yet
  defiAddress: z.string().nullable(),
  email: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
  isBanned: z.boolean(),
  isAmbassador: z.boolean(),
  ambassadorName: z.string().nullable(),
  ambassadorStatusUpdatedAt: z.coerce.date().nullable().optional(),
  nickname: z.string().max(32).nullable().optional(),
});
export type HubUser = z.infer<typeof HubUserSchema>;

export const HubUserWithBanRecordsSchema = HubUserSchema.extend({
  banRecords: z.array(BanRecordSchema),
});
export type HubUserWithBanRecords = z.infer<typeof HubUserWithBanRecordsSchema>;

export type HubUserWithExchangeAccount = HubUser & {
  exchangeAccounts: HubExchangeAccount[];
};

export const BannedHubUsersResponseSchema = z.array(HubUserWithBanRecordsSchema);
export type BannedHubUsersResponse = z.infer<typeof BannedHubUsersResponseSchema>;
